import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@/components/theme/ThemeProvider";
import Home from "./pages/Home";
import HowItWorks from "./pages/HowItWorks";
import Pricing from "./pages/Pricing";
import Auth from "./pages/Auth";
import Dashboard from "./pages/app/Dashboard";
import NewCompany from "./pages/app/NewCompany";
import CompanyDetail from "./pages/app/CompanyDetail";
import NewKPI from "./pages/app/NewKPI";
import KPIDetail from "./pages/app/KPIDetail";
import EditKPI from "./pages/app/EditKPI";
import Recipients from "./pages/app/Recipients";
import CompanySettings from "./pages/app/CompanySettings";
import TeamMembers from "./pages/app/TeamMembers";
import AcceptInvitation from "./pages/app/AcceptInvitation";
import Profile from "./pages/app/Profile";
import Portfolio from "./pages/app/Portfolio";
import Onboarding from "./pages/app/Onboarding";
import NotFound from "./pages/NotFound";
import { ProtectedRoute } from "./components/ProtectedRoute";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <ThemeProvider defaultTheme="dark" storageKey="memo-theme">
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/invite" element={<AcceptInvitation />} />
            <Route
              path="/app"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/app/onboarding"
              element={
                <ProtectedRoute>
                  <Onboarding />
                </ProtectedRoute>
              }
            />
            <Route
              path="/app/portfolio"
              element={
                <ProtectedRoute>
                  <Portfolio />
                </ProtectedRoute>
              }
            />
            <Route
              path="/app/companies/new"
              element={
                <ProtectedRoute>
                  <NewCompany />
                </ProtectedRoute>
              }
            />
            <Route
              path="/app/companies/:id"
              element={
                <ProtectedRoute>
                  <CompanyDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/app/companies/:id/kpis/new"
              element={
                <ProtectedRoute>
                  <NewKPI />
                </ProtectedRoute>
              }
            />
            <Route
              path="/app/companies/:id/kpis/:kpiId"
              element={
                <ProtectedRoute>
                  <KPIDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/app/companies/:id/kpis/:kpiId/edit"
              element={
                <ProtectedRoute>
                  <EditKPI />
                </ProtectedRoute>
              }
            />
            <Route
              path="/app/companies/:id/recipients"
              element={
                <ProtectedRoute>
                  <Recipients />
                </ProtectedRoute>
              }
            />
            <Route
              path="/app/companies/:id/settings"
              element={
                <ProtectedRoute>
                  <CompanySettings />
                </ProtectedRoute>
              }
            />
            <Route
              path="/app/companies/:id/team"
              element={
                <ProtectedRoute>
                  <TeamMembers />
                </ProtectedRoute>
              }
            />
            <Route
              path="/app/profile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </ThemeProvider>
  </QueryClientProvider>
);

export default App;
